import { createPortal } from "react-dom";
import { Keyboard, Mic } from "lucide-react";
import { cn } from "@/lib/utils";
import type { AgentMode } from "./types";

interface AgentModeSwitcherProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: AgentMode;
  onModeChange: (mode: AgentMode) => void;
  children: React.ReactNode;
  align?: "center" | "end";
}

export function AgentModeSwitcher({
  open,
  onOpenChange,
  mode,
  onModeChange,
  children,
  align = "center",
}: AgentModeSwitcherProps) {
  const select = (m: AgentMode) => {
    onModeChange(m);
    onOpenChange(false);
  };

  return (
    <>
      {children}
      {open &&
        createPortal(
          <>
            {/* Backdrop — tapping outside dismisses the menu */}
            <div
              className="fixed inset-0 z-[60]"
              onPointerDown={() => onOpenChange(false)}
            />
            {/* Menu panel */}
            <div
              className={cn(
                "fixed z-[70] w-44 rounded-md border bg-popover p-2 shadow-md",
                align === "center"
                  ? "bottom-16 left-1/2 -translate-x-1/2"
                  : "bottom-24 right-6",
              )}
            >
              <div className="flex flex-col gap-1">
                <button
                  onPointerDown={(e) => e.stopPropagation()}
                  onClick={() => select("voice")}
                  className={cn(
                    "flex items-center gap-2 rounded-md px-3 py-2 text-sm w-full text-left",
                    mode === "voice"
                      ? "bg-accent font-medium"
                      : "hover:bg-accent/50",
                  )}
                >
                  <Mic className="size-4" />
                  Voice Agent
                </button>
                <button
                  onPointerDown={(e) => e.stopPropagation()}
                  onClick={() => select("write")}
                  className={cn(
                    "flex items-center gap-2 rounded-md px-3 py-2 text-sm w-full text-left",
                    mode === "write"
                      ? "bg-accent font-medium"
                      : "hover:bg-accent/50",
                  )}
                >
                  <Keyboard className="size-4" />
                  Write Agent
                </button>
              </div>
            </div>
          </>,
          document.body,
        )}
    </>
  );
}
